module.exports = __webpack_public_path__ + "static/media/sc8r_6.afde725e.gif";